module.exports = __webpack_public_path__ + "img/shangqing.3e57264d.png";